import { ComponentSeason, ComponentSeasonTypes } from '../../../types/Types';

import { useComponentSeasonQuery } from './index';

const getSeasonByType = (seasonType: ComponentSeasonTypes) => {
    const { data: componentSeason = [] } = useComponentSeasonQuery({});
    return componentSeason.find((season) => season.id === seasonType) as ComponentSeason;
};

export default getSeasonByType;
